import { CreditCard } from '@/types';
import { useMemo } from 'react';

export const useCardSelectors = (cards: CreditCard[]) => {
  return useMemo(() => ({
    getById: (id: string) =>
      cards.find(c => c.id === id),
    
    getByBank: (bank: string) =>
      cards.filter(c => c.bank === bank),
    
    getAvailableLimit: (cardId: string) => {
      const card = cards.find(c => c.id === cardId);
      return card ? card.limit - card.used : 0;
    },
    
    getTotalLimit: () =>
      cards.reduce((sum, c) => sum + c.limit, 0),
    
    getTotalUsed: () =>
      cards.reduce((sum, c) => sum + c.used, 0),
    
    getSortedByLimit: () =>
      [...cards].sort((a, b) => b.limit - a.limit),
  }), [cards]);
};
